import { Component, OnInit } from '@angular/core';
import { GeneralService } from '@app/core/http';
import { IResPay } from '@app/core/http/general/general.interface';

@Component({
  selector: 'app-waiting-result',
  templateUrl: './waiting.component.html',
})
export class WaitingResultComponent implements OnInit {
  constructor(private generalService: GeneralService) {}

  paymentResult: IResPay | null = null;

  ngOnInit(): void {
    const result = localStorage.getItem('payment-result') || '';
    this.paymentResult = JSON.parse(result);
  }

  backToMerchant() {
    this.generalService.backToMerchant();
  }
}
